module.exports = __webpack_public_path__ + "img/diashow (6).af43491.jpg";